/**
 * Lern-Quiz — statische Fragen-Decks pro Bodenblick-Thema.
 * 5 Themen × 6 Fragen · Multiple Choice mit Erklärung (Klartext für Laien).
 */
export const QUIZ_TOPICS = [
  {
    id: "boden",
    label: "Boden & Satellit",
    color: "#00FA9A",
    icon: "Leaf",
    teaser: "NDVI, Bodenfeuchte & wie Satelliten Pflanzen sehen.",
    questions: [
      {
        q: "Was misst der NDVI-Wert?",
        options: ["Wie grün und vital Pflanzen sind", "Die Bodentemperatur in 10 cm Tiefe", "Die Anzahl der Regentage pro Monat"],
        correct: 0,
        explain: "NDVI vergleicht reflektiertes Rot- und Infrarotlicht. Gesunde Pflanzen schlucken Rot und spiegeln Infrarot — je höher der Wert (bis 1,0), desto vitaler das Grün.",
      },
      {
        q: "Welcher NDVI-Wert deutet auf sehr vitale Vegetation hin?",
        options: ["0,1", "0,4", "0,8"],
        correct: 2,
        explain: "Werte über 0,6 gelten als kräftiges, dichtes Grün. 0,1 wäre fast kahler Boden, 0,4 ist mittleres Wachstum.",
      },
      {
        q: "Welche Satelliten liefern die Vegetationsdaten für Bodenblick?",
        options: ["GPS-Satelliten", "Copernicus Sentinel-2", "Starlink"],
        correct: 1,
        explain: "Die europäischen Sentinel-2-Satelliten fotografieren jeden Punkt Europas alle paar Tage in 13 Farbkanälen — kostenlos und für alle offen.",
      },
      {
        q: "Warum ist Bodenfeuchte in 0-10 cm Tiefe so wichtig?",
        options: ["Dort leben die meisten Maulwürfe", "Dort keimen Samen und sitzen die feinen Wurzeln", "Sie beeinflusst nur die Bodenfarbe"],
        correct: 1,
        explain: "Der Oberboden ist die Keim- und Wurzelzone. Ist er zu trocken, können Saaten nicht auflaufen — egal wie viel Wasser tiefer liegt.",
      },
      {
        q: "Was passiert mit trockenem Boden bei starkem Regen?",
        options: ["Er saugt alles sofort auf", "Wasser fließt oft oberflächlich ab, statt einzusickern", "Er wird automatisch fruchtbarer"],
        correct: 1,
        explain: "Ausgetrockneter Boden wird wasserabweisend wie ein trockener Schwamm. Starkregen rauscht ab und nimmt wertvollen Humus mit — Erosion.",
      },
      {
        q: "Was verbessert die Wasserspeicherung eines Bodens am nachhaltigsten?",
        options: ["Mehr Humus und Bodenleben", "Häufigeres tiefes Pflügen", "Verdichten mit schweren Maschinen"],
        correct: 0,
        explain: "1 % mehr Humus speichert pro Hektar bis zu 400.000 Liter zusätzliches Wasser. Regenwürmer und Wurzelgänge wirken wie Drainagen.",
      },
    ],
  },
  {
    id: "bienen",
    label: "Bienen & Bestäuber",
    color: "#FFD700",
    icon: "Flower",
    teaser: "Blühfenster, Tracht & warum Wildbienen Helden sind.",
    questions: [
      {
        q: "Ab welcher Temperatur fliegen Honigbienen zuverlässig?",
        options: ["Ab ca. 5 °C", "Ab ca. 12 °C", "Erst ab 25 °C"],
        correct: 1,
        explain: "Unter etwa 12 °C bleiben Honigbienen im Stock. Hummeln sind zäher — sie fliegen schon ab 6-8 °C und retten so die Frühjahrsblüte.",
      },
      {
        q: "Was bedeutet „Tracht“ in der Imkersprache?",
        options: ["Die Kleidung der Imker:innen", "Das Nektar- und Pollenangebot der Umgebung", "Der Tanz der Bienen im Stock"],
        correct: 1,
        explain: "Tracht ist alles, was Bienen sammeln können: Nektar, Pollen und Honigtau. Eine „Massentracht“ wie Raps füllt Waben in wenigen Tagen.",
      },
      {
        q: "Wie viele Wildbienen-Arten gibt es in Deutschland ungefähr?",
        options: ["Rund 60", "Rund 600", "Rund 6.000"],
        correct: 1,
        explain: "Etwa 600 Arten — von der 4-mm-Maskenbiene bis zur Holzbiene. Über die Hälfte steht auf der Roten Liste.",
      },
      {
        q: "Warum sind Wildbienen oft bessere Bestäuber als Honigbienen?",
        options: ["Sie fliegen auch bei Kälte und Nieselregen", "Sie produzieren mehr Honig", "Sie leben in größeren Völkern"],
        correct: 0,
        explain: "Viele Wildbienen arbeiten bei Wetter, das Honigbienen im Stock hält. Mauerbienen bestäuben pro Tier bis zu 50.000 Obstblüten.",
      },
      {
        q: "Welche Fläche hilft Wildbienen am meisten?",
        options: ["Kurz gemähter Zierrasen", "Blühstreifen mit heimischen Wildblumen", "Schotterbeet mit Bambus"],
        correct: 1,
        explain: "Heimische Wildblumen liefern passenden Pollen — viele Wildbienen sind auf bestimmte Pflanzenfamilien spezialisiert. Zierrasen ist für sie eine Wüste.",
      },
      {
        q: "Was passiert mit der Obsternte ohne Bestäuber?",
        options: ["Nichts, Obst bestäubt sich selbst", "Bis zu 90 % weniger Ertrag bei vielen Sorten", "Die Früchte werden nur kleiner, aber gleich viele"],
        correct: 1,
        explain: "Äpfel, Kirschen und Beeren sind fast vollständig auf Insekten angewiesen. Ohne sie blieben die meisten Blüten unbefruchtet.",
      },
    ],
  },
  {
    id: "waldbrand",
    label: "Waldbrand",
    color: "#FF5500",
    icon: "Fire",
    teaser: "FRP, Hot-Spots & richtiges Verhalten im Ernstfall.",
    questions: [
      {
        q: "Wie viele Waldbrände in Mitteleuropa sind menschengemacht?",
        options: ["Etwa 1 von 10", "Etwa die Hälfte", "Etwa 9 von 10"],
        correct: 2,
        explain: "Rund 87-90 % entstehen durch Unachtsamkeit: Zigaretten, Lagerfeuer, heiße Katalysatoren. Blitzschlag ist die seltene Ausnahme.",
      },
      {
        q: "Was misst der FRP-Wert eines Hot-Spots?",
        options: ["Die Strahlungsleistung des Feuers in Megawatt", "Die Fläche des Brandes in Hektar", "Die Windgeschwindigkeit am Brandort"],
        correct: 0,
        explain: "FRP = Fire Radiative Power. Ab etwa 100 MW spricht man von einem Großbrand mit meterhohen Flammen.",
      },
      {
        q: "In welche Richtung flüchtest du bei einem Waldbrand?",
        options: ["Bergauf, weg vom Tal", "Quer zum Wind oder gegen den Hang nach unten", "Immer Richtung dichtestem Wald"],
        correct: 1,
        explain: "Feuer rast bergauf fast doppelt so schnell wie bergab und läuft mit dem Wind. Quer zum Wind und hangabwärts ist der sicherste Weg.",
      },
      {
        q: "Welche Notrufnummer gilt europaweit?",
        options: ["110", "112", "911"],
        correct: 1,
        explain: "112 funktioniert in der ganzen EU, auch ohne Guthaben und ohne Netz des eigenen Anbieters.",
      },
      {
        q: "Warum darf ein Auto nie auf trockenem Gras parken?",
        options: ["Das Gras verfärbt den Lack", "Der heiße Katalysator kann das Gras entzünden", "Die Reifen verlieren Luft"],
        correct: 1,
        explain: "Ein Katalysator wird über 400 °C heiß — trockenes Gras fängt schon bei 300 °C Feuer. 30 Sekunden reichen.",
      },
      {
        q: "Woher stammen die Hot-Spot-Daten auf der Bodenblick-Waldbrandkarte?",
        options: ["Von Feuerwehr-Meldungen", "Von NASA-Satelliten (FIRMS/VIIRS)", "Von Wetterstationen am Boden"],
        correct: 1,
        explain: "NASA FIRMS erkennt Hitzequellen aus dem All mit 375 m Auflösung — mehrmals täglich, weltweit, frei zugänglich.",
      },
    ],
  },
  {
    id: "klima",
    label: "Klima · Damals vs. Heute",
    color: "#8B7CF6",
    icon: "Clock",
    teaser: "Was sich in einer Generation verändert hat.",
    questions: [
      {
        q: "Womit vergleicht Bodenblick das heutige Wetter in „Damals vs. Heute“?",
        options: ["Mit Schätzungen von Zeitzeugen", "Mit ERA5-Klimadaten von vor ca. 30 Jahren", "Mit dem Wetter in Australien"],
        correct: 1,
        explain: "ERA5 ist die Klima-Nachrechnung des europäischen Wetterdienstes ECMWF — stundengenaue Daten zurück bis 1940.",
      },
      {
        q: "Um wie viel hat sich Deutschland seit der Industrialisierung bereits erwärmt?",
        options: ["Ca. 0,3 °C", "Ca. 1,7 °C", "Ca. 5 °C"],
        correct: 1,
        explain: "Deutschland liegt mit rund +1,7 °C über dem globalen Schnitt (+1,2 °C), weil sich Landflächen schneller erwärmen als Ozeane.",
      },
      {
        q: "Was bedeutet eine um 2 °C wärmere Durchschnittstemperatur für Extremwetter?",
        options: ["Kaum etwas, 2 °C spürt man nicht", "Deutlich mehr Hitzetage, Dürren und Starkregen", "Nur mildere Winter, sonst nichts"],
        correct: 1,
        explain: "Der Durchschnitt versteckt die Extreme: 2 °C mehr im Mittel bedeuten ein Vielfaches an Hitzetagen — und wärmere Luft hält 7 % mehr Wasser pro Grad, was Starkregen verstärkt.",
      },
      {
        q: "Wie reagieren Obstbäume auf immer wärmere Frühjahre?",
        options: ["Sie blühen früher — und riskieren Spätfrost-Schäden", "Sie blühen später als früher", "Sie blühen gar nicht mehr"],
        correct: 0,
        explain: "Die Apfelblüte startet heute rund 2 Wochen früher als in den 1960ern. Kommt danach ein Frost, erfrieren die Blüten — Ernteausfall.",
      },
      {
        q: "Was sind Wachstumsgradtage (GDD)?",
        options: ["Die Anzahl der Sonnentage im Jahr", "Aufsummierte Wärme, die Pflanzen für ihre Entwicklung brauchen", "Die Tage, an denen gedüngt werden darf"],
        correct: 1,
        explain: "Pflanzen entwickeln sich nach Wärmesumme, nicht nach Kalender. Mehr GDD = schnellere Reife — verschiebt Aussaat- und Erntefenster.",
      },
      {
        q: "Warum vergleicht man Klimadaten über mindestens 30 Jahre?",
        options: ["Weil ältere Daten fehlen", "Um einzelne Ausreißer-Jahre vom echten Trend zu trennen", "Weil Satelliten nur 30 Jahre halten"],
        correct: 1,
        explain: "Ein einzelnes heißes Jahr ist Wetter. Erst der 30-Jahre-Mittelwert zeigt Klima — so definiert es die Weltwetterorganisation WMO.",
      },
    ],
  },
  {
    id: "wetter",
    label: "Wetter & Boden-Praxis",
    color: "#4DA3FF",
    icon: "CloudSun",
    teaser: "Frost, Verdunstung & die Tages-Ampel verstehen.",
    questions: [
      {
        q: "Was beschreibt die Verdunstung ET₀?",
        options: ["Wie viel Wasser Boden und Pflanzen pro Tag verlieren", "Die Regenmenge pro Quadratmeter", "Die Taubildung am Morgen"],
        correct: 0,
        explain: "ET₀ (Referenz-Verdunstung) zeigt den Wasserbedarf: Ist sie tagelang höher als der Regen, trocknet der Boden aus — Bewässerungs-Signal.",
      },
      {
        q: "Wann ist die Frostgefahr für Blüten am größten?",
        options: ["In klaren, windstillen Nächten nach warmen Tagen", "Bei bedecktem Himmel und Wind", "Nur im tiefsten Winter"],
        correct: 0,
        explain: "Ohne Wolkendecke strahlt der Boden nachts Wärme ungehindert ins All ab. Gefürchtet sind die „Eisheiligen“ Mitte Mai — mitten in der Blüte.",
      },
      {
        q: "Warum ist Bodenfrost schon bei +3 °C Lufttemperatur möglich?",
        options: ["Thermometer messen in 2 m Höhe — am Boden ist es kälter", "Frost hat nichts mit Temperatur zu tun", "Das ist ein Messfehler"],
        correct: 0,
        explain: "Wetterstationen messen in 2 m Höhe. In klaren Nächten kann es direkt am Boden 4-5 °C kälter sein — dort sitzen die jungen Pflanzen.",
      },
      {
        q: "Was zeigt die Bodenblick Tages-Ampel?",
        options: ["Die Verkehrslage auf Feldwegen", "Den ökologischen Gesamtzustand einer Region auf einen Blick", "Ob heute Feiertag ist"],
        correct: 1,
        explain: "Grün/Gelb/Rot fasst NDVI, Bodenfeuchte und Wetterstress zusammen — Klartext statt Zahlenkolonnen.",
      },
      {
        q: "Wie schnell kann ein Hagelschlag eine Ernte vernichten?",
        options: ["In wenigen Minuten", "Frühestens nach einer Stunde", "Hagel schadet Pflanzen kaum"],
        correct: 0,
        explain: "5 Minuten Hagel können ein ganzes Feld zerschlagen. Deshalb sind kurzfristige Warnungen und Prognosen für Höfe so wertvoll.",
      },
      {
        q: "Warum lohnt der Blick auf die 7-Tage-Prognose statt nur auf morgen?",
        options: ["Für Mahd, Aussaat und Ernte braucht man mehrtägige Wetterfenster", "Die Prognose für morgen ist immer falsch", "7 ist eine Glückszahl"],
        correct: 0,
        explain: "Heu braucht z. B. 3 trockene Tage am Stück. Erst das Wetterfenster über mehrere Tage macht Arbeiten planbar.",
      },
    ],
  },
];
